/**
 * Lends community Discord server.
 * Used by the footer social icons, the top bar link and the JoinDiscordPage (/discord).
 */
export const DISCORD_INVITE_URL = 'https://discord.gg/exMrKus9zd';

// In-app route for the "Join our Discord" page
export const DISCORD_PAGE_PATH = '/discord';
